import { useCallback, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'

import SectionToYearCard from './SectionToYearCard'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../config/colors'
import ConfirmFormFooter from '../../../Components/antd/Forms/ConfirmFormFooter'
import { getIdOrNull, isNonEmptyArray } from '../../../utils'

const StudentCardPicker = ({ student, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  const [selectedSection, setSelectedSection] = useState(null)

  const handleSectionClick = section => {
    setSelectedSection(selected => getIdOrNull(selected) === getIdOrNull(section) ? null : section)
  }

  const handleConfirm = e => {
    e.preventDefault()

    onConfirm(selectedSection)
  }

  const selectionStyle = useCallback(section => getIdOrNull(selectedSection) === getIdOrNull(section) ? {
    color: ColorsPalette.BLUE_ICON,
    borderBlock: 'solid',
    borderColor: ColorsPalette.BLUE_ICON,
    borderWidth: '2px'
  } : {}, [selectedSection])

  const hasNoSchool = useMemo(() => !isNonEmptyArray(student.sections), [student.sections])

  return (
    <div className='pd-12 m-4'>
      <div className={`modal-inner-container ${hasNoSchool ? 'error' : ''}`}>
        {hasNoSchool ? (
          <>
            <p className='ft-reg ml-8 mb-0'>{t('student_card_picker.labels.student_has_no_school')}</p>
          </>
        ) : (
          <>
            <p className='ft-reg ml-8'>{t('student_card_picker.labels.student_not_found')}</p>

            <p className='ft-reg ml-8'>{t('student_card_picker.labels.change_school')}</p>

            <div className='flex-column ai-ctr mt-4 mb-4'>
              {student.sections.map((s, i) => (
                <SectionToYearCard
                  key={`${s.id}_${i}`}
                  section={s}
                  className='zoom m-8 pd-4'
                  style={{ ...selectionStyle(s), backgroundColor: ColorsPalette.WHITE }}
                  onClick={handleSectionClick}
                />
              ))}
            </div>
          </>
        )}
      </div>

      <ConfirmFormFooter
        divider
        disabled={hasNoSchool || selectedSection === null}
        confirmTitle='student_card_picker.button.change_school'
        onCancel={onCancel}
        onConfirm={handleConfirm}
      />
    </div>
  )
}

export default StudentCardPicker
